import React from "react";
import { AnalyticsEventTypes } from "../../../functional/analyticsUtils";
import { TelemetryImpression } from "../../TelemetryImpression";
import { ActionHandler } from "../../ActionHandler";
import styled from "styled-components";
export const StylableContentEngagement = ({ className, action, contentAnalytics, intersectionObserverOptions, children, disabled, ...props }) => {
    return (React.createElement(ActionHandler, { action: action, contentAnalytics: contentAnalytics, ...props, className: className, disabled: disabled },
        React.createElement(TelemetryImpression, { impressionEvent: AnalyticsEventTypes.content_impression, analyticsData: { content: contentAnalytics }, intersectionObserverOptions: intersectionObserverOptions }, children)));
};
export const ContentEngagement = styled(StylableContentEngagement) `
  text-decoration: none;
`;
//# sourceMappingURL=ContentEngagement.js.map